import { Container, Paper, Skeleton } from '@mui/material';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import CardDemonstration from 'src/components/CardDemonstration/CardDemonstration';
import MetaTags from 'src/components/Seo/MetaTags';
import { useAuthContext } from 'src/context/AuthContextProvider';
import {
  getInformativeTextByLocation,
  getPayWallBanner,
} from 'src/services/informative';
import { ScrollToTop } from 'src/utils/scroll';

import TimelineExperience from './TimelineExperience';
import TimelineHeader from './components/TimelineHeader';

export default function Timeline() {
  const { auth } = useAuthContext();
  const location = useLocation();
  const hasPermission =
    !!auth.user?.subscription?.plan?.permissions?.linha_do_tempo;
  const { data: description } = useQuery('timelineDescription', () =>
    getInformativeTextByLocation('timeline'),
  );
  const { data: contentPayWallBanner } = useQuery(
    ['paywall', 'timeline'],
    () => getPayWallBanner('timeline'),
    { enabled: !auth.isLoading },
  );

  return (
    <ScrollToTop>
      <MetaTags
        title="Linha do Tempo"
        description="Acompanhe os principais eventos de todas as operações do mercado financeiro."
        canonicalUrl="/linha-do-tempo"
      />
      <Container component="section" maxWidth="xl" sx={{ pb: 5 }}>
        <TimelineHeader
          subtitle={description?.data?.timeline?.informationText}
        />
        <TimelineExperience hasPermission={hasPermission} />
        {auth.isLoading ? (
          <Paper
            elevation={0}
            sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
            <Skeleton variant="rounded" height={180} />
          </Paper>
        ) : !hasPermission ? (
          <Paper elevation={2} sx={{ p: 2, borderRadius: 1, minHeight: 420 }}>
            <CardDemonstration
              title={contentPayWallBanner?.timeline?.title}
              subTitle={contentPayWallBanner?.timeline?.subTitle}
              labelButton={
                auth.isLoggedIn
                  ? contentPayWallBanner?.timeline?.labelButton
                  : 'Acessar'
              }
              url={
                auth.isLoggedIn
                  ? contentPayWallBanner?.timeline?.url
                  : `/login?redirectUrl=${location.pathname}${location.search}`
              }
            />
          </Paper>
        ) : null}
      </Container>
    </ScrollToTop>
  );
}
